window.Plyr = require("plyr");

const playerInstance = document.querySelector(".hero-video-carousel #plyr-player-instance");
const playerWrapper = document.querySelector("#plyr-wrapper");

if (playerInstance) {
    // Initialize Plyr player when DOM is loaded
    document.addEventListener("DOMContentLoaded", () => {
        window.player = new Plyr(".hero-video-carousel #plyr-player-instance", {
            fullscreen: true,
            autoplay: true
        });

        window.player.on('ready', function() {
            let iframe = document.querySelector('.plyr__video-embed iframe');
            if (iframe) {
                iframe.style.visibility = 'visible';
            }
        });

        window.player.on('playing', function() {
            playerWrapper.classList.add('fade-in');
        });

        window.player.on('ended', function() {
            playerWrapper.classList.remove('fade-in');
        });

        window.player.on('pause', function() {
            playerWrapper.classList.remove('fade-in');
        });
    });

    // Change video source when the player-src element is clicked
    document.addEventListener("DOMContentLoaded", () => {
        const playerSrcElements = document.querySelectorAll(".player-src");

        playerSrcElements.forEach((playerSrc) => {
            playerSrc.addEventListener("click", function () {
                let videoSrc = this.dataset.video || this.dataset.src;

                // Check if it's a YouTube ID
                const isYouTube = videoSrc && (
                    videoSrc.length === 11 || // Standard YouTube ID length
                    videoSrc.includes('youtube.com') ||
                    videoSrc.includes('youtu.be')
                );

                if (isYouTube) {
                    // Extract YouTube ID if it's a full URL
                    if (videoSrc.includes('youtube.com') || videoSrc.includes('youtu.be')) {
                        const matches = videoSrc.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/);
                        if (matches) {
                            videoSrc = matches[1];
                        }
                    }

                    // Set YouTube source configuration
                    window.player.source = {
                        type: 'video',
                        sources: [{
                            src: videoSrc,
                            provider: 'youtube'
                        }]
                    };
                } else {
                    // Handle local MP4 video
                    window.player.source = {
                        type: 'video',
                        title: '1.61 Video Player',
                        sources: [{
                            src: videoSrc,
                            type: 'video/mp4'
                        }]
                    };
                }


                const playVideo = async () => {
                    try {
                        await window.player.play();
                    } catch (error) {
                        console.warn('Autoplay failed:', error);
                    }
                };

                setTimeout(playVideo, 100);
            });
        });
    });
}